export default {
  "HOME": "होम"
};